import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button, Label, Input, FormGroup, Badge } from 'reactstrap';
import Select from 'react-select';
import styled from 'styled-components';
import 'react-block-ui/style.css';
import config from '../../../config';

const ErrorMessage = styled.small`
  color: rgb(242, 108, 79);
  font-size: 0.875rem;
  line-height: 1.2;
  display: block;
  margin-top: 5px;
`;

const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
`;

const Tag = styled(Badge)`
  display: inline-flex;
  align-items: center;
  background-color: #dbe6ff !important;
  color: #818181 !important;
  padding: 5px 10px;
  font-size: 0.875rem;
  border-radius: 4px;
`;

const RemoveButton = styled.button`
  border: none !important;
  color: #dc3545;
  margin-left: 8px;
  cursor: pointer;
  font-size: 1rem;
`;

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.selectProps.hasError
      ? 'rgb(242, 108, 79)'
      : provided.borderColor,
    '&:hover': {
      borderColor: state.selectProps.hasError
        ? 'rgb(242, 108, 79)'
        : provided.borderColor,
    },
  }),
};

const validate = (values) => {
  const errors = {};
  if (!values.lang) {
    errors.lang = 'Required';
  }
  if (!values.vocabulary || values.vocabulary.length === 0) {
    errors.vocabulary = 'At least one tag is required';
  }
  return errors;
};

const LanguageSelect = ({ input, meta }) => (
  <div className="form-group">
    <Label for="lang">Language</Label>
    <Select
      id="lang"
      options={config.langOptions}
      value={config.langOptions.find((option) => option.value === input.value)}
      onChange={(option) => input.onChange(option ? option.value : '')}
      onBlur={() => input.onBlur(input.value)}
      styles={customStyles}
      hasError={meta.touched && meta.error}
    />
    {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
  </div>
);

const VocabularyInput = ({ input, meta }) => {
  const [currentTag, setCurrentTag] = React.useState('');

  const handleAddTag = (e) => {
    if (e.key === 'Enter' && currentTag.trim()) {
      e.preventDefault();
      const newTags = [...(input.value || []), currentTag.trim()];
      input.onChange(newTags);
      setCurrentTag('');
    }
  };

  const handleBlur = () => {
    if (currentTag.trim()) {
      const newTags = [...(input.value || []), currentTag.trim()];
      input.onChange(newTags);
      setCurrentTag('');
    }
    input.onBlur(input.value || []);
  };

  const handleRemoveTag = (tagToRemove) => {
    const newTags = (input.value || []).filter((tag) => tag !== tagToRemove);
    input.onChange(newTags);
  };

  return (
    <FormGroup>
      <Label for="vocabulary">Vocabulary</Label>
      <TagContainer>
        {(input.value || []).map((tag, index) => (
          <Tag key={index}>
            {tag}
            <RemoveButton
              type="button"
              onClick={() => handleRemoveTag(tag)}
              aria-label={`Remove ${tag}`}
            >
              &times;
            </RemoveButton>
          </Tag>
        ))}
      </TagContainer>
      <Input
        type="text"
        id="vocabulary"
        value={currentTag}
        onChange={(e) => setCurrentTag(e.target.value)}
        onKeyPress={handleAddTag}
        onBlur={handleBlur}
        placeholder="Add vocabulary tag and press enter"
        invalid={meta.touched && meta.error}
      />
      {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
    </FormGroup>
  );
};

const VoiceProfileForm = ({ handleSubmit, submitting }) => (
  <form onSubmit={handleSubmit}>
    <Field name="lang" component={LanguageSelect} />
    <Field name="vocabulary" component={VocabularyInput} />
    <Button
      color="primary"
      type="submit"
      disabled={submitting}
      style={{
        opacity: submitting ? 0.6 : 1,
        cursor: submitting ? 'not-allowed' : 'pointer',
      }}
    >
      Update Voice Profile
    </Button>
  </form>
);

export default connect((state) => ({}))(
  reduxForm({
    form: 'voiceProfile',
    validate,
    enableReinitialize: true,
  })(VoiceProfileForm)
);
